import { render, staticRenderFns } from "./W3Channels.vue?vue&type=template&id=5569d8d0&scoped=true"
import script from "./W3Channels.vue?vue&type=script&lang=js"
export * from "./W3Channels.vue?vue&type=script&lang=js"
import style0 from "./W3Channels.vue?vue&type=style&index=0&id=5569d8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5569d8d0",
  null
  
)

export default component.exports